import { c as _c } from "react/compiler-runtime";
import { PassiveTooltip } from '@systemeio/components';
import { CheckIcon, Copy03Icon } from '@systemeio/icons';
import { useEffect, useRef, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { copyTextToClipboard } from 'shared/utils/copy-text-to-clipboard';
import { twMerge } from 'tailwind-merge';
interface CopyInputValueButtonProps {
  className?: string;
  disabled?: boolean;
  onCopy?: () => void;
  text: string;
}
function CopyInputValueButton(t0) {
  const $ = _c(26);
  const {
    className,
    disabled,
    onCopy,
    text
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [isCopied, setIsCopied] = useState(false);
  const copiedTimeoutRef = useRef(undefined);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => () => {
      if (copiedTimeoutRef.current) {
        clearTimeout(copiedTimeoutRef.current);
      }
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== onCopy || $[3] !== text) {
    t3 = async () => {
      const copied = await copyTextToClipboard(text, false);
      if (!copied) {
        setIsCopied(false);
        return;
      }
      onCopy?.();
      setIsCopied(true);
      if (copiedTimeoutRef.current) {
        clearTimeout(copiedTimeoutRef.current);
      }
      copiedTimeoutRef.current = setTimeout(() => setIsCopied(false), 1500);
    };
    $[2] = onCopy;
    $[3] = text;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleCopy = t3;
  let t4;
  if ($[5] !== isCopied || $[6] !== t) {
    t4 = isCopied ? t("global.copy_clipboard") : t("global.copy");
    $[5] = isCopied;
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isCopied) {
    t5 = isCopied ? <CheckIcon aria-hidden="true" className="text-icon-accent size-4" /> : <Copy03Icon aria-hidden="true" className="text-icon-secondary hover:text-icon-accent transition-base size-4" />;
    $[8] = isCopied;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      side: "bottom"
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("global.copy");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== className) {
    t8 = twMerge("focus-visible:[&_svg]:text-icon-accent focus-visible:focus-ring-primary outline-none", className);
    $[13] = className;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== handleCopy) {
    t9 = () => void handleCopy();
    $[15] = handleCopy;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== disabled || $[18] !== t7 || $[19] !== t8 || $[20] !== t9) {
    t10 = {
      closeOnClick: false,
      render: <button aria-label={t7} className={t8} disabled={disabled} onClick={t9} type="button" />
    };
    $[17] = disabled;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t4 || $[24] !== t5) {
    t11 = <PassiveTooltip content={t4} trigger={t5} positionerProps={t6} triggerProps={t10} />;
    $[22] = t10;
    $[23] = t4;
    $[24] = t5;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}
export { CopyInputValueButton };
export type { CopyInputValueButtonProps };